type OnMigration = 'add' | 'remove';
type AddonAvailability = 'included' | 'optional';

export type FeatureRecord = {
  label: string;
  tooltip: string;
  fromScale?: OnMigration;
  fromLaunch?: OnMigration;
};
export type AddonRecord = {
  label: string;
  tooltip: string;
  availability: AddonAvailability;
};

export const StartFeatures: FeatureRecord[] = [
  {
    label: 'app.pricing.plan_picker_2024.features.multi_job_posting.label',
    tooltip: 'app.pricing.plan_picker_2024.features.multi_job_posting.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.careers_hub_single_page.label',
    tooltip: 'app.pricing.plan_picker_2024.features.careers_hub_single_page.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.parse_and_search_cv.label',
    tooltip: 'app.pricing.plan_picker_2024.features.parse_and_search_cv.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.email_and_calendar_sync.label',
    tooltip: 'app.pricing.plan_picker_2024.features.email_and_calendar_sync.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.quick_evaluations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.quick_evaluations.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.pipeline_templates.label',
    tooltip: 'app.pricing.plan_picker_2024.features.pipeline_templates.tooltip',
    fromScale: 'remove',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.pipeline_automations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.pipeline_automations.tooltip',
    fromScale: 'remove',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.automated_emails.label',
    tooltip: 'app.pricing.plan_picker_2024.features.automated_emails.tooltip',
    fromScale: 'remove',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.talent_pools.label',
    tooltip: 'app.pricing.plan_picker_2024.features.talent_pools.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.basic_reporting_and_analytics.label',
    tooltip: 'app.pricing.plan_picker_2024.features.basic_reporting_and_analytics.tooltip',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.unlimited_data_storage.label',
    tooltip: 'app.pricing.plan_picker_2024.features.unlimited_data_storage.tooltip',
  },
];
export const GrowFeatures: FeatureRecord[] = [
  {
    label: 'app.pricing.plan_picker_2024.features.careers_hub_multi_page.label',
    tooltip: 'app.pricing.plan_picker_2024.features.careers_hub_multi_page.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.custom_domain.label',
    tooltip: 'app.pricing.plan_picker_2024.features.custom_domain.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.referrals_hub.label',
    tooltip: 'app.pricing.plan_picker_2024.features.referrals_hub.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.event_scheduler.label',
    tooltip: 'app.pricing.plan_picker_2024.features.event_scheduler.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.evaluation_forms.label',
    tooltip: 'app.pricing.plan_picker_2024.features.evaluation_forms.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.questionnaires.label',
    tooltip: 'app.pricing.plan_picker_2024.features.questionnaires.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.knockout_questions.label',
    tooltip: 'app.pricing.plan_picker_2024.features.knockout_questions.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.multi_locations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.multi_locations.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.multi_languages.label',
    tooltip: 'app.pricing.plan_picker_2024.features.multi_languages.tooltip',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.custom_reporting_and_analytics.label',
    tooltip: 'app.pricing.plan_picker_2024.features.custom_reporting_and_analytics.tooltip',
    fromLaunch: 'add',
  },
];
export const OptimizeFeatures: FeatureRecord[] = [
  {
    label: 'app.pricing.plan_picker_2024.features.onboarding_support.label',
    tooltip: 'app.pricing.plan_picker_2024.features.onboarding_support.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.dedicated_customer_success_manager.label',
    tooltip: 'app.pricing.plan_picker_2024.features.dedicated_customer_success_manager.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.fair_evaluations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.fair_evaluations.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.requisition_approvals.label',
    tooltip: 'app.pricing.plan_picker_2024.features.requisition_approvals.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.bi_connection.label',
    tooltip: 'app.pricing.plan_picker_2024.features.bi_connection.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.sso.label',
    tooltip: 'app.pricing.plan_picker_2024.features.sso.tooltip',
    fromScale: 'add',
    fromLaunch: 'add',
  },
];

export const StartAddons: AddonRecord[] = [
  {
    label: 'app.pricing.plan_picker_2024.features.texting.label',
    tooltip: 'app.pricing.plan_picker_2024.features.texting.tooltip',
    availability: 'optional',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.sso.label',
    tooltip: 'app.pricing.plan_picker_2024.features.sso.tooltip',
    availability: 'optional',
  },
];
export const GrowAddons: AddonRecord[] = [
  // temp; will be brought back
  // {
  //   label: 'app.pricing.plan_picker_2024.features.onboarding_support.label',
  //   tooltip: 'app.pricing.plan_picker_2024.features.onboarding_support.tooltip',
  //   availability: 'optional'
  // },
  {
    label: 'app.pricing.plan_picker_2024.features.texting.label',
    tooltip: 'app.pricing.plan_picker_2024.features.texting.tooltip',
    availability: 'optional',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.sso.label',
    tooltip: 'app.pricing.plan_picker_2024.features.sso.tooltip',
    availability: 'optional',
  },
];
export const OptimizeAddons: AddonRecord[] = [
  {
    label: 'app.pricing.plan_picker_2024.features.texting.label',
    tooltip: 'app.pricing.plan_picker_2024.features.texting.tooltip',
    availability: 'optional',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.onboarding_support.label',
    tooltip: 'app.pricing.plan_picker_2024.features.onboarding_support.tooltip',
    availability: 'included',
  },
  {
    label: 'app.pricing.plan_picker_2024.features.sso.label',
    tooltip: 'app.pricing.plan_picker_2024.features.sso.tooltip',
    availability: 'included',
  },
];
